import Jimp from 'jimp/es';
import Tesseract from 'tesseract.js';

export const OcrActionTypes = {
    RecognizeText: 'RecognizeText',
    RecognizeTextDone: 'RecognizeTextDone',
    ClearRecognizedText: 'ClearRecognizedText',
    ClearRecognizedTextDone: 'ClearRecognizedTextDone',
};

export const OcrModes = {
    All: 'All',
    UpperMiddleLine: 'UpperMiddleLine',
};

function _getCanvasBlob(canvas) {
    return (new Promise(function (resolve, reject) {
        canvas.toBlob(function (blob) {
            if (blob !== null) {
                resolve(blob);
            } else {
                reject(new Error('Blob of canvas is null.'));
            }
        });
    }));
}

export const recognizeText = (canvas, mode) => {
    return async (dispatch, getState) => {
        try {
            const { recognizeTextCompletedInState } = getState().ocrState;

            if (recognizeTextCompletedInState === false) {
                return;
            }

            dispatch({
                type: OcrActionTypes.RecognizeText,
            });

            const blob = await _getCanvasBlob(canvas);
            const arrayBuffer = await blob.arrayBuffer();
            const jimpImage = await Jimp.read(arrayBuffer);

            jimpImage.greyscale();

            const base64DataUrl = await jimpImage.getBase64Async(Jimp.MIME_PNG);
            const result = await Tesseract.recognize(base64DataUrl, 'eng', {
                logger: m => { },
            });

            let text;

            switch (mode) {
                case OcrModes.All:
                    text = result.data.text;

                    break;
                case OcrModes.UpperMiddleLine:
                    const lineCount = result.data.lines.length;

                    if (lineCount > 0) {
                        const lineNumber = Math.ceil(lineCount / 2) - 1;

                        text = result.data.lines[lineNumber].text;
                    } else {
                        text = '';
                    }

                    break;
                default:
                    text = result.data.text;
            }

            text = text.trim();

            dispatch({
                type: OcrActionTypes.RecognizeTextDone,
                text: text,
            });
        } catch (error) {
            dispatch({
                type: OcrActionTypes.RecognizeTextDone,
                error: error,
            });
        }
    };
};

export const clearRecognizedText = () => {
    return async (dispatch, getState) => {
        try {
            dispatch({
                type: OcrActionTypes.ClearRecognizedText,
            });

            dispatch({
                type: OcrActionTypes.ClearRecognizedTextDone,
            });
        } catch (error) {
            dispatch({
                type: OcrActionTypes.ClearRecognizedTextDone,
                error: error,
            });
        }
    };
};
